import * as firebase from 'firebase';
import Timestamp = firebase.firestore.Timestamp;
import {Astrowetter} from './astrowetter';
import {WintersportWetterTexte, RbbWintersportWetterWerte} from './rbb-wintersport-wetter';
import {RbbWassersportWetter} from './rbb-wassersport-wetter';

export class MesswertMeteogroupRbb {

  astrowetter: Astrowetter;
  wintersportWetterTexte: WintersportWetterTexte;
  wintersportWetterWerte: RbbWintersportWetterWerte;
  wassersportWetter: RbbWassersportWetter;
}

export class MesswertMeteoGroupRbbMetaData {
  datum: string;
  update: Date;
  zeitstempel: Timestamp;
  id: string;
  service: string;
}
